module.exports = __webpack_public_path__ + "img/2025-01-09c_1.ded54cae.jpg";